<template>
  <b-card id="settings-lookups-card">
    <b-card-header
      id="title"
      class="p-0 mb-1"
    >
      <h4 class="mb-0">
        {{ $t('settings.lookups') }}
      </h4>
      <b-card-text
        class=" mb-0"
      >
        <feather-icon
          icon="HelpCircleIcon"
          size="21"
          class="cursor-pointer"
          @click="help"
        />
      </b-card-text>
    </b-card-header>
    <b-card-body class="p-0">
      <b-form class="mt-1">
        <b-row>

          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              :label="$t('settings.lookups-table')"
              label-for="tables"
              label-class="mb-1"
            >
              <b-form-radio-group
                id="tables"
                v-model="selected"
                :options="tables"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              id="values"
              :label="$t('settings.lookups-values')"
              label-for="values"
            >
              <div class="d-flex align-items-center justify-content-end">
                <v-select
                  v-model="valor"
                  :options="lookupOptions"
                  class="w-100"
                  :placeholder="$t('common.select-one')"
                  :reduce="val => val.label"
                />
                <b-button
                  variant="outline-primary"
                  :disabled="!selected"
                  @click="refreshMap()"
                >
                  {{ $t('common.refresh') }}
                </b-button>
              </div>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              :label="$t('settings.lookups-replacer')"
              label-for="replacer"
            >
              <b-form-input
                id="replacer"
                v-model="replacer"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <b-button
              id="btn-replace"
              class="btn-block"
              variant="outline-primary"
              :disabled="!valor || !replacer"
              @click="replace()"
            >
              <span class="text-nowrap d-none d-sm-block">{{ $t('settings.lookups-replace') }}</span>
            </b-button>
          </b-col>
        </b-row>

        <hr>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              id="obsoletes"
              :label="$t('settings.lookups-obsoletes')"
              label-for="obsoletes"
            >
              <div class="d-flex align-items-center justify-content-end">
                <v-select
                  v-model="obsoletes"
                  :options="lookupOptions"
                  multiple
                  class="w-100"
                  :placeholder="$t('common.select-one')"
                  :reduce="val => val.label"
                />
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-card-body>
    <app-tour :steps="helps" />
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BCardHeader, BCardText, BFormGroup, BFormRadioGroup, BForm, BFormInput, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import AppTour from '@core/components/app-tour/AppTour.vue'
import i18n from '@/libs/i18n'
import lookupsService from '@/vue.lookups.service'
import { swalCustomOptions, toastSuccessOptions } from '../layouts/layouts.utils'

export default {
  components: {
    BRow, BCol, BCard, BCardBody, BCardHeader, BCardText, BForm, BFormInput, BFormGroup, BFormRadioGroup, vSelect, AppTour, BButton,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    refaid: {
      required: true,
    },
    settings: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selected: null,
      valor: null,
      replacer: null,
      lookupOptions: [],
      obsoletes: null,
      tables: [
        { text: i18n.t('projects.nation'), value: 'nations' },
        { text: i18n.t('projects.mission'), value: 'projects.missionName' },
        { text: i18n.t('projects.triboo'), value: 'projects.triboo' },
        { text: i18n.t('projects.filter-project-type'), value: 'projects.projectType' },
        { text: i18n.t('projects.status'), value: 'projects.status' },
        { text: i18n.t('contributors.status'), value: 'contributors.status' },
        { text: i18n.t('contributors.contributor-type'), value: 'contributors.contributorType' },
        { text: i18n.t('donations.filter-payments-label'), value: 'donations.payments' },
        { text: i18n.t('donations.filter-donations-label'), value: 'donations.type' },
        { text: i18n.t('donations.filter-category-label'), value: 'donations.category' },
        { text: i18n.t('donations.givers-type'), value: 'donations.giversType' },
      ],
      helps: [
        {
          target: '#settings-lookups-card #tables',
          header: { title: i18n.t('help.step-1') },
          content: i18n.t('help.settings-lookups-table'),
          params: { enableScrolling: false },
        },
        {
          target: '#settings-lookups-card #values',
          header: { title: i18n.t('help.step-2') },
          content: i18n.t('help.settings-lookups-values'),
          params: { enableScrolling: false },
        },
        {
          target: '#settings-lookups-card #btn-replace',
          header: { title: i18n.t('help.step-3') },
          content: i18n.t('help.settings-lookups-btn-replace'),
          params: { enableScrolling: false },
        },
        {
          target: '#settings-lookups-card #obsoletes',
          header: { title: i18n.t('help.step-4') },
          content: i18n.t('help.settings-lookups-obsoletes'),
          params: { enableScrolling: false },
        },
      ],

    }
  },
  async mounted() {
    this.$watch('refaid', () => {
      this.selected = null
      this.reset()
    })
    this.$watch('selected', async () => {
      if (this.selected && this.refaid) {
        this.reset()
        await this.load(this.selected)
      }
    })
    this.$watch('obsoletes', () => {
      if (this.selected && this.refaid && this.obsoletes) {
        if (this.settings[this.selected] || this.obsoletes.length > 0) {
          if (!this.settings[this.selected]) this.settings.lastUpdate = new Date()
          this.settings[this.selected] = this.obsoletes
        }
      }
    })
  },
  methods: {
    reset() {
      this.lookupOptions = []
      this.obsoletes = null
      this.valor = null
      this.replacer = null
    },
    async load(table) {
      this.lookupOptions = await lookupsService.getMaps(table, this.refaid)
      const obs = this.settings[table] ?? []
      this.obsoletes = obs
    },
    help() {
      this.$tours.vuexyTour.start()
    },
    replace() {
      this.$swal(swalCustomOptions('settings.replace-warning', 'settings.replace-warning2'))
        .then(async result => {
          if (result.value === true) {
            await lookupsService.replaceValues(this.selected, this.refaid, this.valor, this.replacer)
            this.reset()
            this.selected = null
            this.$toast(toastSuccessOptions, { position: 'top-center' })
          }
        })
    },
    refreshMap() {
      this.$swal(swalCustomOptions('settings.refresh-warning', 'settings.refresh-warning2'))
        .then(async result => {
          if (result.value === true) {
            await lookupsService.refreshRemoteMaps(this.selected, this.refaid, true)
            this.reset()
            await this.load(this.selected)
            this.$toast(toastSuccessOptions, { position: 'top-center' })
          }
        })
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/tour.scss';

.custom-radio {
  margin-bottom: 15px;
  margin-right: 25px;
}

</style>
